import type { AccountOcpsPolicies } from '../store/schema/OutlookCloudPoliciesSchema';
import {
    FeatureToAllowUserOverrideSettingIdMap,
    type OcpsPolicyFeature,
    type OutlookCloudPolicySettingId,
} from '../store/schema/OutlookCloudPolicyTypes';
import { settingIdToFeature } from './featureSettingIds';

export function getMissingEnforcedPolicySettingIds(
    policies: AccountOcpsPolicies
): OutlookCloudPolicySettingId[] {
    const missingSettingIds: OutlookCloudPolicySettingId[] = [];
    const featureSettingIds = Object.entries(settingIdToFeature) as [
        OutlookCloudPolicySettingId,
        OcpsPolicyFeature
    ][];

    for (const [feature, allowUserOverrideSettingId] of Object.entries(
        FeatureToAllowUserOverrideSettingIdMap
    ) as [OcpsPolicyFeature, OutlookCloudPolicySettingId][]) {
        const featurePolicies = policies[feature];
        if (featurePolicies?.[allowUserOverrideSettingId]?.value !== '0') {
            continue;
        }

        for (const [settingId, settingFeature] of featureSettingIds) {
            if (
                settingFeature === feature &&
                settingId !== allowUserOverrideSettingId &&
                !featurePolicies[settingId]
            ) {
                missingSettingIds.push(settingId);
            }
        }
    }

    return missingSettingIds;
}
